import React, { useRef, useEffect, useState } from "react";
import Calendar from "./calendarSelect";
import CalendarIcon from "../../icons/calendar";

interface DateInputProps {
  value: string;
  onSelect: (dateTime: string) => void;
  placeholder?: string;
  onlyFuture?: boolean;
}

const DateInput: React.FC<DateInputProps> = ({
  value,
  onSelect,
  placeholder = "Выберите дату",
  onlyFuture = false
}) => {
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const calendarRef = useRef<HTMLDivElement>(null);

  // Обработчик выбора даты из Calendar
  const handleDateSelect = (dateTime: string) => {
    onSelect(dateTime); // Передаем выбранную дату в родительский компонент
    // setIsCalendarVisible(false); // Скрываем календарь после выбора
  };

  // Обработчик клика за пределами календаря
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target as Node)
      ) {
        setIsCalendarVisible(false); // Скрываем календарь
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dateInputContainer">
      <input
        type="text"
        value={value.replace("T", " ")}
        readOnly
        placeholder={placeholder}
        onClick={() => setIsCalendarVisible(!isCalendarVisible)}
      />
      <div className="dateIcon">
        <CalendarIcon width={24} height={24} />
      </div>
      {isCalendarVisible && (
        <div className="calendarWrapper" ref={calendarRef}>
          <Calendar onSelect={handleDateSelect} onlyFuture={onlyFuture} />
        </div>
      )}
    </div>
  );
};

export default DateInput;